module.exports = __webpack_public_path__ + "img/icon.4bdeca74.png";